module.exports = __webpack_public_path__ + "static/img/2_1_4.76325f40.jpg";